import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

let initialNews = { active: false, keyword: /berg/i, link: "https://teams.microsoft.com/l/message/19:de2957c13b10493c8288298fe80ccbc3@thread.tacv2/1773660503648?tenantId=f6e03af0-f62c-4ef2-a542-c02a29109b93&groupId=a597b6ed-144a-496d-9e1f-dee799af880e&parentMessageId=1773660503648&teamName=Baur%20Immobilien%20e.K.&channelName=General&createdTime=1773660503648", title: "Benachrichtigungen aktivieren" };

export default function News({}) {
   const [keyword, setKeyword] = useState("");

   const [show, setShow] = useState(() => {
      let oldKeyword = localStorage.getItem("keyword") ? localStorage.getItem("keyword") : "";

      return !initialNews.keyword.test(oldKeyword);
   });

  

   const handleClose = () => {
      setShow(false);
   };
   const dogGif =
      "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExdXM5NXQza3hybDhuN216YXZtbW4wd3Rxc21jdmdtMGYzdGZveW1vOCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/PyvS7IL0myhDW/giphy.gif";
   const breakingNewsGif =
      "https://media0.giphy.com/media/v1.Y2lkPTc5MGI3NjExc3J0dDk2YWdlcG12ZHg5MXcxYnBlOXZvbG4wZHV1OGV1d3B6Z2RiMCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/fXbKU733xxQGHv9dIW/giphy.gif";
   const officeGif =
      "https://media4.giphy.com/media/v1.Y2lkPTc5MGI3NjExZDVpNnAwOTF6eDZjaWo0MmtzMTlrd3V6NG94MGd5Ymt1b3k2dXBzciZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/10mg1YnJMmJgkM/giphy.gif"; //"https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExd3p1MXc5cWZjNXY4eGl4dm02bm9oNGRsZWR6NTdta3o4Nm1ocTE0ZiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/gd6bBl4IExkXPK07Kx/giphy.gif"

   const officeNo =
      "https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExMnlsNDcydDdhaGhuamF4aTBxamZla2xwc2czaTIxZGtzd2Q4dTNncCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/NpL4D3Oc2bJUMAXF9P/giphy.gif";
   return (
      <>
         {initialNews.active && (
            <Modal show={show} onHide={handleClose} size="xl" className="" backdrop="static" keyboard={false}>
               <Modal.Body className="mx-5">
                  {/* {tries ? (
                     <div className="text-center my-5">
                      <img style={{ borderRadius: "20px", width: "40%" }} alt="Neuigkeiten" src={officeNo} />
                     </div>
                  ) : (
                     <></>
                  )} */}
                  <h2 className="my-4">Wichtige Neuigkeiten</h2>
                  Bitte bei Teams den neuen Beitrag zu{" "}
                  <strong>
                     {" "}
                     <a href={initialNews.link}> {initialNews.title} ↗</a>{" "}
                  </strong>{" "}
                  lesen und zum Bestätigen das Schlüsselwort eingeben.
                  <div className="mt-2">
                     <label className="checkbox-container">
                        Schlüsselwort:
                        <input
                           type="text"
                           onChange={(e) => {
                              localStorage.setItem("keyword", e.target.value);
                              let keywordTest = !initialNews.keyword.test(e.target.value);
                              setShow(keywordTest);
                              setKeyword(e.target.value);
                           }}
                        />
                     </label>
                  </div>
               </Modal.Body>
               <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                     Vorübergehend schließen
                  </Button>
               </Modal.Footer>
            </Modal>
         )}
      </>
   );
}
